import { Instance } from 'mobx-state-tree'
import { DailyTaskAcfModelBase } from './DailyTaskAcfModel.base'

/* The TypeScript type of an instance of DailyTaskAcfModel */
export interface DailyTaskAcfModelType extends Instance<typeof DailyTaskAcfModel.Type> {}

/* A graphql query fragment builders for DailyTaskAcfModel */
export {
  selectFromDailyTaskAcf,
  dailyTaskAcfModelPrimitives,
  DailyTaskAcfModelSelector
} from './DailyTaskAcfModel.base'

/**
 * DailyTaskAcfModel
 */
export const DailyTaskAcfModel = DailyTaskAcfModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
